import {useDebugValue} from 'react';

import {undef} from '../../../utils';

import {useSettings} from './';

const defaultSettings = {
    width: undef,
    height: undef,
    isMobile: false,
    isTablet: false,
    isDesktop: false
};

function useMediaSettings(props) {
    const {
        mediaSettings: propsSettings
    } = props;

    const {
        initialSettings,
        settings,
        changeSettings
    } = useSettings(defaultSettings, propsSettings);

    const result = {
        initialSettings,
        settings,
        changeSettings
    };

    useDebugValue(result);

    return result;
}

export {useMediaSettings};
